var map = {
	"./wealth_level_0.png": "jPfn",
	"./wealth_level_1.png": "RCIi",
	"./wealth_level_10.png": "EVIO",
	"./wealth_level_100.png": "LfYP",
	"./wealth_level_11.png": "POM2",
	"./wealth_level_12.png": "+zpt",
	"./wealth_level_13.png": "MlvN",
	"./wealth_level_14.png": "onP7",
	"./wealth_level_15.png": "8qE2",
	"./wealth_level_16.png": "Fofz",
	"./wealth_level_17.png": "ZVXd",
	"./wealth_level_18.png": "iWXY",
	"./wealth_level_19.png": "Bvv9",
	"./wealth_level_2.png": "Cwa/",
	"./wealth_level_20.png": "A93y",
	"./wealth_level_21.png": "FUyF",
	"./wealth_level_22.png": "3ngN",
	"./wealth_level_23.png": "At2+",
	"./wealth_level_24.png": "fkts",
	"./wealth_level_25.png": "S73S",
	"./wealth_level_26.png": "xw8j",
	"./wealth_level_27.png": "VLKr",
	"./wealth_level_28.png": "hlyK",
	"./wealth_level_29.png": "eSR9",
	"./wealth_level_3.png": "K8+i",
	"./wealth_level_30.png": "lk9s",
	"./wealth_level_31.png": "RGMa",
	"./wealth_level_32.png": "jfZ3",
	"./wealth_level_33.png": "8Qxc",
	"./wealth_level_34.png": "rSM2",
	"./wealth_level_35.png": "ex+M",
	"./wealth_level_36.png": "LBE9",
	"./wealth_level_37.png": "j/I5",
	"./wealth_level_38.png": "agB2",
	"./wealth_level_39.png": "6fSu",
	"./wealth_level_4.png": "alFe",
	"./wealth_level_40.png": "LWsR",
	"./wealth_level_41.png": "vsUw",
	"./wealth_level_42.png": "BCb6",
	"./wealth_level_43.png": "mFrJ",
	"./wealth_level_44.png": "QR0A",
	"./wealth_level_45.png": "Ki8T",
	"./wealth_level_46.png": "9lCB",
	"./wealth_level_47.png": "x9Xy",
	"./wealth_level_48.png": "jGjc",
	"./wealth_level_49.png": "HiCt",
	"./wealth_level_5.png": "p6uk",
	"./wealth_level_50.png": "/tzd",
	"./wealth_level_51.png": "Fnwo",
	"./wealth_level_52.png": "7uR9",
	"./wealth_level_53.png": "j+sU",
	"./wealth_level_54.png": "rdiJ",
	"./wealth_level_55.png": "swRs",
	"./wealth_level_56.png": "CVh7",
	"./wealth_level_57.png": "Ms3O",
	"./wealth_level_58.png": "gZi7",
	"./wealth_level_59.png": "Xi7n",
	"./wealth_level_6.png": "NGuK",
	"./wealth_level_60.png": "YScK",
	"./wealth_level_61.png": "oOZm",
	"./wealth_level_62.png": "UWQ/",
	"./wealth_level_63.png": "6RTN",
	"./wealth_level_64.png": "ul4M",
	"./wealth_level_65.png": "rMmr",
	"./wealth_level_66.png": "lvET",
	"./wealth_level_67.png": "c32l",
	"./wealth_level_68.png": "1YyM",
	"./wealth_level_69.png": "q2hD",
	"./wealth_level_7.png": "Bm2R",
	"./wealth_level_70.png": "gWC0",
	"./wealth_level_71.png": "9gWe",
	"./wealth_level_72.png": "69PW",
	"./wealth_level_73.png": "ADO5",
	"./wealth_level_74.png": "VZBG",
	"./wealth_level_75.png": "5CQn",
	"./wealth_level_76.png": "nhks",
	"./wealth_level_77.png": "4DsO",
	"./wealth_level_78.png": "vGix",
	"./wealth_level_79.png": "24gW",
	"./wealth_level_8.png": "O2Ge",
	"./wealth_level_80.png": "B3rC",
	"./wealth_level_81.png": "Bg2k",
	"./wealth_level_82.png": "lo30",
	"./wealth_level_83.png": "a20J",
	"./wealth_level_84.png": "JWPz",
	"./wealth_level_85.png": "p3Ar",
	"./wealth_level_86.png": "8uZt",
	"./wealth_level_87.png": "FHQV",
	"./wealth_level_88.png": "v9LB",
	"./wealth_level_89.png": "8ugC",
	"./wealth_level_9.png": "YlTD",
	"./wealth_level_90.png": "+A5o",
	"./wealth_level_91.png": "3B7w",
	"./wealth_level_92.png": "nwGC",
	"./wealth_level_93.png": "zWEE",
	"./wealth_level_94.png": "7Dfq",
	"./wealth_level_95.png": "eIAE",
	"./wealth_level_96.png": "tfc2",
	"./wealth_level_97.png": "a51m",
	"./wealth_level_98.png": "xXrP",
	"./wealth_level_99.png": "1W3q"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eh5p";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level ^\.\/wealth_level_.*\.png$
// module id = eh5p
// module chunks = 0